export default __webpack_public_path__ + "static/media/expand.1a4729a8.svg";